var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/ecf67698/0/pomelo/oceopin/web/app/themes/oceopin/node_modules/core-js/modules/_user-agent.js
// module id = 92
// module chunks = 0